import React, { useState, useEffect, useRef } from "react";

import "./businessDetail.scss";
import { useLocation, Navigate, useParams, Link } from "react-router-dom";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { BusinessBySlugId } from "../../slices/thunks";
import withRouter from "../../components/withRouter";
import Loader from "../../components/Loader";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ReviewModal from "../../components/ReviewModal";
import { getAllReviews } from "../../slices/reviews/thunk";
import { ToastContainer } from "react-toastify";

const BusinessDetail = (props) => {
  const { slug } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const perPage = 10;

  const [item, setItem] = useState(location.state || null);
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(!location.state);
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);

  const { businessBySlugId } = useSelector((state) => ({
    businessBySlugId: state.Business.businessBySlugId,
  }));
  const { postById, isPostByIdSuccess } = useSelector((state) => ({
    postById: state.Posts.postById,
    isPostByIdSuccess: state.Posts.isPostByIdSuccess,
  }));

  useEffect(() => {
    if (!item && slug) {
      setLoading(true);
      dispatch(BusinessBySlugId(slug, navigate)).finally(() =>
        setLoading(false)
      );
    }
  }, [dispatch, slug, item, navigate]);

  useEffect(() => {
    if (!location.state && businessBySlugId) {
      setItem(businessBySlugId);
    }
  }, [businessBySlugId, location.state]);

  useEffect(() => {
    if (item?._id) {
      fetchReviews(item._id);
    }
  }, [item]);

  const fetchReviews = async (pageNumber) => {
    const res = await dispatch(
      getAllReviews({
        page: pageNumber,
        perPage,
        searchText: "",
        businessId: item._id,
      })
    );
    console.log(res);
    if (res?.payload?.items?.length) {
      if (pageNumber === 1) {
        setReviews(res.payload.items);
      } else {
        setReviews((prev) => [...prev, ...res.payload.items]);
      }

      // Check if fewer than perPage returned, means no more to load
      setHasMore(res.payload.items.length === perPage);
    } else {
      setHasMore(false); // no more data
    }
  };

  // If no slug or failed fetch, redirect to businesses page
  if (!slug || (businessBySlugId?.status === false && !location.state)) {
    return <Navigate to="/businesses" />;
  }

  if (loading) {
    return <Loader />; // Show loader while fetching data
  }
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="company-profile">
          <ToastContainer closeButton={false} />
          <div className="header">
            <div className="logo">
              <img src={item?.logo} alt="Company Logo" />
            </div>
            <div className="info">
              <h1>{item?.business_name}</h1>
              <div className="rating">
                <span className="stars">★★★★☆</span>
                <span className="score">4.0</span>
                <span className="reviews">4 reviews</span>
              </div>
              <span className="tag">{item?.business_category}</span>
              <div className="actions">
                <button
                  className="btn"
                  onClick={() => setIsReviewModalOpen(true)}
                >
                  Write a review
                </button>
                <Link to={item?.website} className="btn outline">
                  Visit website
                </Link>
              </div>
            </div>
            {/* <div className="scorebox">
              <div className="score">4.0</div>
              <div className="label">Great</div>
              <div className="bar-group">
                {[...Array(5)].map((_, i) => (
                  <div
                    key={i}
                    className={`bar bar-${i === 0 ? "full" : "empty"}`}
                  ></div>
                ))}
              </div>
            </div> */}
          </div>

          <div className="disclaimer">
            Companies on Softorithm can’t offer incentives or pay to hide any
            reviews.
          </div>

          <div className="details">
            <h2>Company details</h2>
            <span className="tag small">{item?.business_category}</span>
            <div className="description">
              <strong>Written by the company</strong>
              <p>{item?.description}</p>
            </div>

            <div className="contact-section">
              <h2 className="contact-heading">Contact info</h2>
              <ul className="contact-list">
                <li>
                  <i className="ri-map-pin-line icon"></i>{" "}
                  <span>{item?.location}</span>
                </li>
                <li>
                  <i className="ri-global-line icon"></i>{" "}
                  <Link to={item?.website?.replace(/^https?:\/\//, "")}>
                    {item?.website?.replace(/^https?:\/\//, "")}
                  </Link>
                </li>
                <li className="contact-socials">
                  {item?.facebook && (
                    <Link to={item.facebook}>
                      <i className="ri-facebook-line"></i>{" "}
                    </Link>
                  )}
                  {item?.twitter && (
                    <Link to={item.twitter}>
                      <i className="ri-twitter-line"></i>{" "}
                    </Link>
                  )}
                  {item?.linkedin && (
                    <Link to={item.linkedin}>
                      <i className="ri-linkedin-line"></i>{" "}
                    </Link>
                  )}
                </li>
              </ul>
            </div>
          </div>

          <div className="reviews-section">
            <h2>Customer Reviews</h2>
            {reviews.length > 0 ? (
              reviews.map((review) => (
                <div className="review-card" key={review._id}>
                  <div className="review-header">
                    <span className="review-rating">
                      {"★".repeat(review.rating)}
                      {"☆".repeat(5 - review.rating)}
                    </span>
                    <span className="review-title">{review.title}</span>
                  </div>
                  <p className="review-comment">{review.comment}</p>
                  <div className="review-meta">
                    <span>By user</span> |{" "}
                    <span>
                      {new Date(review.created_at).toLocaleDateString()}
                    </span>
                  </div>
                </div>
              ))
            ) : (
              <p>No reviews yet. Be the first to write one!</p>
            )}
          </div>
        </div>
      )}
      <ReviewModal
        businessdetail={item}
        isOpen={isReviewModalOpen}
        onClose={() => setIsReviewModalOpen(false)}
      />
    </>
  );
};

export default withRouter(BusinessDetail);
